/**
 * Length limits the SERVER enforces, restated here so the screen can say
 * so before the user hits them.
 *
 * THESE ARE COPIES, AND COPIES DRIFT. Each one duplicates a Pydantic
 * `max_length` in api/models/schemas.py, and nothing in either language
 * can see the other. If the server is raised to 30000 and this file is
 * not, the box keeps stopping at 20000 and the extra room is invisible;
 * if the server is LOWERED and this is not, the user types happily to a
 * limit that no longer exists and is rejected after writing -- which is
 * the exact failure the counter was added to prevent, reintroduced by
 * the fix for it.
 *
 * So limits.test.js reads schemas.py and asserts every number here still
 * matches. That test is the only thing making this file safe, and the
 * same reasoning as reference-config-vs-constraint: a config table in
 * one language asserted against the authority in another.
 */

/** api/models/schemas.py: JournalCreateRequest / JournalUpdateRequest */
export const JOURNAL_BODY_MAX = 20000;
